$(document).on("turbo:load", () => {
  const optionsToggle = $('.toggle')

  $(optionsToggle).click(function() {
    $('.message-actions').toggleClass('active')
  })
})
